// 登录相关API
import request from '@/utils/request'

/**
 * 密码登录
 * @param {Object} data - 登录数据
 * @param {string} data.mobile - 手机号
 * @param {string} data.password - 密码
 * @returns {Promise}
 */
export function login(data) {
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}

/**
 * 验证码登录
 * @param {Object} data - 登录数据
 * @param {string} data.mobile - 手机号
 * @param {string} data.captcha - 短信验证码
 * @param {number} data.cid - 客户端ID（固定：1）
 * @param {number} data.client - 客户端类型（固定：3）
 * @param {number} data.event - 事件类型（固定：1）
 * @returns {Promise}
 */
export function loginByCode(data) {
  return request({
    url: '/user/loginForCaptcha',
    method: 'post',
    data
  })
}
// 获取腾讯IM
export function obtainUsersig(data) {
  return request({
    url: '/user/obtainUsersig',
    method: 'post',
    data
  })
}
/**
 * 发送验证码
 * @param {Object} data - 发送参数
 * @param {string} [data.mobile] - 手机号（推荐）
 * @param {string} [data.phone] - 手机号（兼容旧字段，将自动映射为 mobile）
 * @returns {Promise}
 */
export function sendCode(data) {
  const payload = {
    ...data
  }
  // 兼容旧字段：如果传入 phone，则映射到 mobile
  if (payload.phone && !payload.mobile) {
    payload.mobile = payload.phone
  }

  return request({
    url: '/sms/aliSend',
    method: 'post',
    data: payload
  })
}

/**
 * 忘记密码（通过短信验证码）
 * POST /user/forgetPwd
 * @param {Object} data
 * @param {string} data.mobile - 手机号
 * @param {string} data.captcha - 短信验证码
 * @param {number} data.cid - 客户端ID（固定：1）
 * @param {number} data.client - 客户端类型（固定：3）
 * @param {number} data.event - 事件类型（固定：1）
 * @param {string} [data.newPwd] - 新密码（如后端支持一起提交）
 * @param {string} [data.confirmNewPwd] - 确认新密码
 * @returns {Promise}
 */
export function forgetPwd(data) {
  return request({
    url: '/user/forgetPwd',
    method: 'post',
    data
  })
}

/**
 * 修改密码
 * POST /user/changePwd
 * @param {Object} data
 * @param {string} data.newPwd - 新密码
 * @param {string} data.confirmNewPwd - 确认新密码
 * @param {number} data.type - 1：旧密码验证；2：手机号验证
 * @param {string} [data.oldPwd] - 旧密码（type=1 时必传）
 * @returns {Promise}
 */
export function changePwd(data) {
  return request({
    url: '/user/changePwd',
    method: 'post',
    data
  })
}

/**
 * 变更手机号
 * POST /user/changeMobile
 * @param {Object} data
 * @param {string} data.mobile - 新手机号
 * @param {string} data.captcha - 短信验证码
 * @param {number} data.event - 事件类型（固定：1）
 * @returns {Promise}
 */
export function changeMobile(data) {
  return request({
    url: '/user/changeMobile',
    method: 'post',
    data
  })
}

/**
 * 注册账号
 * @param {Object} data - 注册数据
 * @param {string} data.phone - 手机号
 * @param {string} data.code - 验证码
 * @param {string} data.password - 密码
 * @returns {Promise}
 */
export function register(data) {
  return request({
    url: '/user/register',
    method: 'post',
    data
  })
}

/**
 * 绑定手机号
 * @param {Object} data - 绑定数据
 * @param {string} data.phone - 手机号
 * @param {string} data.code - 验证码
 * @param {string} data.password - 密码（可选）
 * @returns {Promise}
 */
export function bindOpenId(data) {
  return request({
    url: '/user/bindOpenId',
    method: 'post',
    data
  })
}

/**
 * 微信扫码登录回调
 * GET /user/callback
 * @param {Object} params
 * @param {string} params.code - 微信授权回调 code
 */
export function wechatCallback(params) {
  return request({
    url: '/user/callback',
    method: 'get',
    params
  })
}
/**
 * 获取图片验证码
 * GET /chenduo-app/common/captcha/image
 */
export function captchaImage(params) {
  return request({
    url: '/chenduo-app/common/captcha/image',
    method: 'get',
    params
  })
}
// 验证图片验证码
export function validateCaptcha(data) {
  return request({
    url: '/chenduo-app/common/captcha/validate',
    method: 'post',
    data
  })
}
// 三方登录
export function mobileThirdLogin(data) {
  return request({
    url: '/user/mobileThirdLogin',
    method: 'post',
    data
  })
}